export default __webpack_public_path__ + "static/media/Report-Default.27377e2d.svg";